export  const colors = [
  "rgba(154, 64, 224, 1)",
  "rgba(76, 175, 80, 1)",
  "rgba(255, 152, 0, 1)",
 " rgba(53, 146, 251, 1)",
  "#ff0000ab",
  "#34656D",
  "#FAEAB1",
  "#334443",
  "#6B3F69",
  "#BB6653",
];